import {z} from 'zod';

export const CancelOrderWithReasonFormSchema = z.object({
  reason: z.string().min(1),
});

export type CancelOrderWithReasonFormType = z.infer<typeof CancelOrderWithReasonFormSchema>;
